import React, { useState, useEffect } from 'react'
import './AddBoxModalContainer.scoped.sass'

import { ReactComponent as CloseIcon } from '@/assets/icons/close-icon.svg'
import { Button } from '@/components/Button/Button'
import { InputMask } from '@/components/InputMask/InputMask'
import { Radio } from '@/components/Radio/Radio'
import labelsService from '@/app-domains/labels/labels.service'
import boxesService from '@/app-domains/boxes/boxes.service'

export function AddBoxModalContainer (props) {
  const {
    closeAddLabelModal,
    box
  } = props
  const [boxAlias, setBoxAlias] = useState(box ? (box.boxalias || box.boxname) : '')
  const [errorMessage, setErrorMessage] = useState('')
  const [selectedLabels, setSelectedLabels] = useState(labelsService.findLabelsForBox(box))
  const [showLabelCreationInput, setShowLabelCreationInput] = useState(false)
  const [newLabelValue, setNewLabelValue] = useState('')
  const [newLabelErrorMessage, setNewLabelErrorMessage] = useState('')
  useEffect(() => {
    if (box) {
      setSelectedLabels(labelsService.findLabelsForBox(box))
    }
  }, [])

  const haveBoxesLabelChanged = (box, selectedLabels) => {
    if ((!box.boxlabels || box.boxlabels?.length === 0) && selectedLabels.length > 0) return true
    if (box.boxlabels.length !== selectedLabels.length) return true

    // If number of labels selected is the same than the one the box has, we have to compare them and check
    const labelsExistingInBox = selectedLabels.filter(
      label => {
        return box.boxlabels.filter(blabel => blabel.id === label.id).length > 0
      }).length
    return labelsExistingInBox !== selectedLabels.length
  }
  const addBox = async () => {
    if (!boxAlias) {
      setErrorMessage('Field cannot be empty')
      return
    } else {
      setErrorMessage('')
    }

    if (showLabelCreationInput && newLabelValue.length === 0) {
      setNewLabelErrorMessage('Field cannot be empty')
      return
    }

    const promisesArray = []

    if ((box.boxalias && boxAlias !== box.boxalias) || (!box.boxalias && boxAlias !== box.boxname)) {
      const changeBoxNamePromise = boxesService.changeBoxName({ box, boxAlias: boxAlias })
        .then(() => {}, (err) => {
          throw new Error(err)
        })
      promisesArray.push(changeBoxNamePromise)
    }

    if (!showLabelCreationInput && haveBoxesLabelChanged(box, selectedLabels)) {
      const changeBoxLabelsPromise = boxesService
        .attachLabelsToBox(box, selectedLabels)
        .then(() => {}, (err) => {
          throw new Error(err)
        })
      promisesArray.push(changeBoxLabelsPromise)
    }

    if (showLabelCreationInput && newLabelValue.length > 0) {
      const newLabel = await labelsService.createBoxLabel(newLabelValue)
      await boxesService.attachLabelsToBox(box, newLabel)
    }

    Promise.all(promisesArray)
      .then(closeAddLabelModal)
      .then()
  }

  const onLabelSelected = (newlySelectedLabel) => {
    if (selectedLabels.find((label) => label.composedid === newlySelectedLabel.composedid)) {
      const newSelectedLabels = selectedLabels.filter((label) => label.composedid !== newlySelectedLabel.composedid)
      setSelectedLabels(newSelectedLabels)
    } else {
      setSelectedLabels([newlySelectedLabel, ...selectedLabels])
    }
  }

  return <div className='add-label-modal'>
    <div className="add-label-top">
      <div className="title">
        {(box ? 'Edit' : 'Create a')} box
      </div>
      <div className="close-button" onClick={closeAddLabelModal}>
        <CloseIcon />
      </div>
    </div>
    <div className="add-label-content">
      <div className="input-label">
        <div className="input-label-title">
          Box Alias
        </div>
        <div className="input">
          <InputMask
            errorMessage={errorMessage}
            value={boxAlias}
            onInput={(value) => setBoxAlias(value)}
            placeholder={'Name your label'} />
        </div>
      </div>
      <div className="input-label">
        <div className="input-label-title">
          Box Name
        </div>
        <div className="input">
          <InputMask
            errorMessage={errorMessage}
            value={props.box.boxname}
            disabled={true}
            placeholder={''} />
        </div>
      </div>
    </div>
    <div className="select-label">
      <div className="select-label-title">
        Labels
      </div>
      { !showLabelCreationInput && <div className="radios">
        {Object.values(labelsService.getLabelsFromStore()).map((label, index) => {
          return <Radio
            key={index}
            label={label?.name}
            name={label?.name}
            onChecked={() => onLabelSelected(label)}
            checked={selectedLabels.filter((sl) => sl.composedid === label.composedid).length > 0} />
        })}
      </div>
      }
      { !showLabelCreationInput && <div className="create-new-label-box-modal" onClick={() => setShowLabelCreationInput(true) }>
        I want to create a new label for this box
      </div> }
      { showLabelCreationInput && <div className="input-label">
        <div className="input">
          <InputMask
            errorMessage={newLabelErrorMessage}
            value={newLabelValue}
            placeholder={'Please type label name'}
            onInput={setNewLabelValue}
            label='New label' />
        </div>
      </div>}
      { showLabelCreationInput && <div className="create-new-label-box-modal" onClick={() => setShowLabelCreationInput(false) }>
        Nevermind, I prefer to add an existing label to this box
      </div> }
    </div>
    <div className="add-label-bottom">
      <div className="cancel">
        <Button type={'secondary'} content={'Cancel'} click={closeAddLabelModal} />
      </div>
      <div>
        <Button content={(box ? 'Save' : 'Create Box')} click={addBox} />
      </div>
    </div>
  </div>
}
